import React, {h, Component, PropTypes} from 'preact';
import './PromoteListingAlreadyListedProp.scss';
import PromoteListingModal from './PromoteListingModal';

export default class PromoteListingAlreadyListedProp extends PromoteListingModal {

    constructor(props) {
        super(props);
    }

    handleFileChange(event) {

        const file = event.target.files[0];

        if (file.type != "application/pdf") {
            this.fileInputRef.current.value = '';
            this.setState({
                file: null,
                error: 'The file you provided must have a PDF format.'
            });
            return;
        }
        else {
            super.handleFileChange(event);
        }
    }

    render() {
        const {isLoading, uploaded, error, url, file} = this.state;
        const {requestId, onUploadFinished} = this.props;

        return (
            <div className="nu-modal mobile-full-screen promote-listing-modal-sub">
                <div className="modal-dialog-sub">
                    {!uploaded &&
                        <form
                            action="alreadyListed-uploadAgreement-json"
                            method="POST"
                            encType="multipart/form-data"
                            className="modal-content-sub"
                            onSubmit={this.handleFormSubmit.bind(this)}>
                            <input type="hidden" name="requestId" value={requestId}/>
                            <input type="hidden" name="clientUploadAgreement" value="true"/>

                            <div className="modal-body">

                                {file ?
                                    <div className="mb-2x mb-3x-sm file-preview">
                                        <img src={global.imageBaseUrl + 'proposal/document.svg'}/>
                                        {file.name || 'File.pdf'}
                                        <a className="touch-opacity" onClick={this.handleRemoveFileButtonClick.bind(this)}>
                                            <img className="file-icon" src={global.imageBaseUrl + 'proposal/delete.svg'}/>
                                        </a>
                                    </div>
                                    : [
                                        <div key="url" className="mb-2x mb-3x-sm mr-1x">
                                            <input
                                                type="url"
                                                name="listingAgreementUrl"
                                                value={this.state.url}
                                                placeholder="Paste URL of a PDF document"
                                                className="form-control url-input"
                                                onInput={this.handleUrlChange.bind(this)}/>
                                        </div>,
                                        <div key="file" className="big-message">
                                            or
                                            <button
                                                type="button"
                                                className="ml-1x btn btn-gray-outline file-button"
                                                onClick={this.handleChooseButtonClick.bind(this)}>
                                                Choose File
                                            </button>

                                        </div>
                                    ]
                                }
                                <input
                                    ref={this.fileInputRef}
                                    type="file"
                                    name="agreement"
                                    accept=".pdf"
                                    style="display: none"
                                    onChange={this.handleFileChange.bind(this)}/>
                            </div>
                            <div className="modal-footer-sub">

                                {error && <div className="error mt-2x mr-2x mb-2x">{error}</div>}

                                <button
                                    type="submit"
                                    className="btn btn-default"
                                    disabled={isLoading || error || (!url && !file)}
                                    onClick={() => trackEvent('Quote', 'uploadAgreement')}>
                                    Upload Listing
                                </button>
                            </div>
                            {isLoading &&
                                <div className="loadingSpinner" style="display: block; margin: 0">
                                    <img src={global.imageBaseUrl + 'spinner.gif'}/>
                                </div>
                            }
                        </form>
                    }
                </div>
            </div>
        );
    }
}
